module.exports = __webpack_public_path__ + "img/51600.f3c764a5.jpg";